import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";

export const fetchEvolutionStatus = createAsyncThunk(
  "evolution/fetchStatus",
  async (establishmentId: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/evolution/status`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const connectEvolution = createAsyncThunk(
  "evolution/connect",
  async (
    payload: { establishmentId: string; force?: boolean; name?: string },
    thunkAPI,
  ) => {
    try {
      const { establishmentId, ...body } = payload;
      const response = await axiosInstance.post(`/evolution/connect`, body);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);

export const deleteEvolution = createAsyncThunk(
  "evolution/delete",
  async (establishmentId: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/evolution`);
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        return thunkAPI.rejectWithValue({ error: error.message });
      }
      return thunkAPI.rejectWithValue({ error: "Unknown error" });
    }
  },
);
